import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_DEV } from "../consts.js"

export const axaHkIbm = {
	"axahkibm-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_DEV }
}
